import { ERROR_CODE_LABEL, httpChipClass } from "./vocab";

/**
 * Response chip for a delivery or attempt.
 *   • got an HTTP status  → "HTTP 500", coloured by class (2xx green, 3xx
 *     blue, 4xx amber, 5xx red)
 *   • no status but an error code → its short label on red ("TIMEOUT",
 *     "TLS", "DNS", "BLOCKED", … "ERR" for anything unknown)
 *   • neither (nothing was attempted yet) → renders nothing
 * @param status    `lastResponseStatus` / `responseStatus`
 * @param errorCode `lastErrorCode` / `errorCode`
 */
export function HttpStatusChip({
  status,
  errorCode,
  className = "",
}: {
  status: number | null | undefined;
  errorCode?: string | null;
  className?: string;
}) {
  const hasStatus = typeof status === "number" && status > 0;
  if (!hasStatus && !errorCode) return null;

  const text = hasStatus ? `HTTP ${status}` : ERROR_CODE_LABEL[errorCode as string] || "ERR";
  return (
    <span
      title={!hasStatus && errorCode ? errorCode : undefined}
      className={`inline-block shrink-0 rounded px-2 py-0.5 text-[11px] font-bold tabular-nums whitespace-nowrap ${httpChipClass(
        hasStatus ? status : null,
      )} ${className}`}
    >
      {text}
    </span>
  );
}

export default HttpStatusChip;
